import { Text } from '@mnd-frontend/ui/publish/components';
import { useTranslation } from 'react-i18next';

const BackdatingStory = () => {
  const [t] = useTranslation();
  return (
    <>
      <Text as="h3" variant="headlineSmall">
        {t('help_panel_publish-backdating-title')}
      </Text>
      <Text as="p" variant="body">
        {t('help_panel_publish-backdating-content')}
      </Text>
    </>
  );
};

export default BackdatingStory;
